import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.scss';
import { formatCardFilterText } from '../../../../../utils/formatFilterText';
import ArticleCardBlock from './article_card_block';
import {
  setTabOrPublicationPage,
  setLastPublicationNumber,
} from '../../../../../redux/slices/appSlice';
import { setCurrentPublication } from '../../../../../redux/slices/currentPublicationSlice';

const ArticleCard = ({ publication, globalIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.currentTab.currentTab);
  const imgs_for_filters = useSelector((state) => state.others_data.imgs_for_filters);
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (publicationData && publicationData.content) {
      try {
        const parsedContent = JSON.parse(publicationData.content);
        setContentData(parsedContent);
      } catch (error) {
        setContentData(null);
      }
    }
  }, [publicationData]);

  const handleDetailsClick = () => {
    if (!publicationData || !currentTab) return;
    const targetPath =
      currentTab.eng_name === 'main_tab'
        ? '/' + publicationData.eng_name
        : '/' + currentTab.eng_name + '/' + publicationData.eng_name;
    if (globalIndex) {
      dispatch(setLastPublicationNumber(globalIndex));
    }
    dispatch(setCurrentPublication(publicationData));
    dispatch(setTabOrPublicationPage('publication'));
    navigate(targetPath);
  };

  const filterA = React.useMemo(() => {
    if (!publication?.publication_settings) return null;
    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_a || null;
    } catch (error) {
      return null;
    }
  }, [publication?.publication_settings]);

  const filterB = React.useMemo(() => {
    if (!publication?.publication_settings) return null;
    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_b || null;
    } catch (error) {
      return null;
    }
  }, [publication?.publication_settings]);

  const firstBlock =
    contentData && Array.isArray(contentData) && contentData.length > 0 ? contentData[0] : null;

  return (
    <div className={styles.articleCard}>
      {filterB && filterB !== 'все' && (
        <div className={styles.filterBDisplay}>
          {formatCardFilterText(filterB)}
        </div>
      )}

      {firstBlock ? (
        <ArticleCardBlock
          blockData={firstBlock}
          path_to_folder={'https://' + publicationData?.path + publicationData.eng_name + '/'}
          onDetailsClick={handleDetailsClick}
          filterA={filterA}
          filterB={filterB}
          globalIndex={globalIndex}
          imgs_for_filters={imgs_for_filters}
        />
      ) : (
        <div className={styles.noBlocksMessage}>Блоки не найдены</div>
      )}
    </div>
  );
};

export default ArticleCard;
